export enum NotificationChannel {
  EMAIL = 'email'
}
